import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Container,
  AppBar,
  Toolbar,
  Typography,
  TextField,
  Button,
  Select,
  MenuItem,
  Box,
} from "@mui/material";
import DatePicker from "react-date-picker";
import "react-date-picker/dist/DatePicker.css";
import { auth, db } from "../firebase"; // Asegúrate de importar tus configuraciones de Firebase
import {
  doc,
  getDoc,
  addDoc,
  collection,
  serverTimestamp,
} from "firebase/firestore";
import Atras from "./atras";

const Publish = () => {
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    price: "",
    skills: "",
    timeToDo: new Date(), // Inicializamos con una fecha por defecto
  });
  const [publishSuccess, setPublishSuccess] = useState(false); // Estado para controlar el éxito
  const navigate = useNavigate(); // Hook para redireccionar

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
  };

  const handleDateChange = (newDate) => {
    setFormData((prevFormData) => ({ ...prevFormData, timeToDo: newDate }));
  };

  const handlePublishProyect = async () => {
    const { uid } = auth.currentUser || {};

    const userDocRef = doc(db, "users", uid);
    const userDocSnapshot = await getDoc(userDocRef);

    if (userDocSnapshot.exists()) {
      const userData = userDocSnapshot.data();
      const userName = userData.displayName;

      await addDoc(collection(db, "projects"), {
        name: userName,
        title: formData.title,
        description: formData.description,
        price: formData.price,
        skills: [formData.skills],
        timeToDo: formData.timeToDo,
        createdAt: serverTimestamp(),
        status: "abierto",
        uid,
      });
      setPublishSuccess(true);
    } else {
      console.error("User document does not exist");
    }
  };

  const handleRedirectHome = () => {
    navigate("/home");
  };

  return (
    <Container>
      <AppBar position="fixed">
        <Toolbar
          sx={{
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            padding: "10px",
          }}
        >
          <Atras color="inherit" />
          <Container>
            <Typography variant="h5" color="text.primary" gutterBottom>
              Publicar Proyecto
            </Typography>
          </Container>
        </Toolbar>
      </AppBar>
      <Container sx={{ mt: 14 }}>
        <TextField
          autoFocus
          margin="dense"
          id="title"
          label="Título del proyecto"
          type="text"
          fullWidth
          name="title"
          value={formData.title}
          onChange={handleInputChange}
        />
        <TextField
          margin="dense"
          id="description"
          label="Descripción del proyecto"
          type="text"
          fullWidth
          name="description"
          multiline
          rows={5}
          value={formData.description}
          onChange={handleInputChange}
        />
        <TextField
          margin="dense"
          id="price"
          label="Presupuesto (USD$)"
          type="text"
          fullWidth
          name="price"
          value={formData.price}
          onChange={handleInputChange}
        />
        <Typography sx={{mt:2}}>Habilidad requerida para el proyecto:</Typography>
        <Select
          label="Habilidad"
          type="text"
          name="skills"
          sx={{ mt: 1.5, marginBottom: 1 }}
          value={formData.skills}
          onChange={handleInputChange}
          displayEmpty
          fullWidth
        >
          <MenuItem value="" disabled>
            Selecciona una habilidad
          </MenuItem>
          <MenuItem value="Diseño Web">Diseño Web</MenuItem>
          <MenuItem value="Diseño UX/UI">Diseño UX/UI</MenuItem>
          <MenuItem value="Diseño Grafico">Diseño Gráfico</MenuItem>
          <MenuItem value="Programación">Programación</MenuItem>
          <MenuItem value="Desarrollo de Apps">Desarrollo de Apps</MenuItem>
          <MenuItem value="Community Manager">Community Manager</MenuItem>
          <MenuItem value="Marketing Digital">Marketing Digital</MenuItem>
          <MenuItem value="Diseño Multimedia">Diseño Multimedia</MenuItem>
          <MenuItem value="Edición de Videos">Edición de Videos</MenuItem>
          <MenuItem value="Edición de Imágenes">Edición de Imágenes</MenuItem>
          <MenuItem value="Redacción de Contenidos">Redacción de Contenidos</MenuItem>
          <MenuItem value="Traducción">Traducción</MenuItem>
        </Select>
        <Typography sx={{mt:2}}>Fecha de entrega:</Typography>
        <DatePicker
          margin="dense"
          label="Fecha de entrega"
          format="MM/dd/yyyy"
          onChange={handleDateChange}
          value={formData.timeToDo}
        />
        {publishSuccess && (
          <Box sx={{ textAlign: "center" }}>
            <Typography>El proyecto se ha publicado correctamente.</Typography>
            <Button onClick={handleRedirectHome} color="primary">
              Ir a Proyectos
            </Button>
          </Box>
        )}
        {!publishSuccess && (
          <Button
            variant="contained"
            sx={{ mt: 3 }}
            fullWidth
            onClick={handlePublishProyect}
            color="primary"
          >
            Publicar
          </Button>
        )}
      </Container>
    </Container>
  );
};

export default Publish;
